module.exports = __webpack_public_path__ + "img/vehicule_000.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/img/photos/vehicule_000.jpg
// module id = 371
// module chunks = 0